// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bgColor_appBar: var(--cw-color-back-primary);
  --fgColor_spinner: #2e78ac;
  --height_topAppBar: 60px;
  --cw-color-primary: #217cbb;
  --cw-color-text-primary: #252a2e;
  --cw-color-text-secondary: rgba(37, 42, 46, 0.7);
  --cw-color-text-hint: rgba(37, 42, 46, 0.5);
  --cw-color-back-primary: #fff;
  --cw-color-back-blue: #dcedf9;
  --cw-color-divider-primary: rgba(37, 42, 46, 0.65);
  --cw-color-divider-secondary: rgba(37, 42, 46, 0.15);
  --cwui-color-palette-warn: #da212c;
}
:root .btn.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0063a3;
  --bs-btn-border-color: #0063a3;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0082d6;
  --bs-btn-hover-border-color: #0082d6;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #00548a;
  --bs-btn-active-border-color: #00548a;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0063a3;
  --bs-btn-disabled-border-color: #0063a3;
}
:root .btn.btn-light {
  --bs-btn-color: #252a2e;
}
:root .card {
  --bs-card-bg: var(--cw-color-back-primary);
}
:root .navbar {
  --bs-navbar-padding-x: 16px;
  --bs-navbar-padding-y: 2.25px;
}
h1 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-block-end: 24px;
}
.TlR_oP5QZdjlSQqYXk5F {
  padding: 32px;
  padding-block-end: 16px;
  inline-size: clamp(320px, 30lvi, 500px);
}
.ojm_WdoHMlG3FmU_o9Zh {
  font-size: 0.875rem;
  color: var(--cw-color-text-secondary);
}
.eBocShHzGg1byhAAkym5 {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: stretch;
  /****** oauth 2 ******/
}
.eBocShHzGg1byhAAkym5 .gkpk_9wRdIUYtCtGMHzw {
  margin: 10px;
  color: red;
  max-inline-size: 300px;
  background-color: #ff00000a;
  padding: 8px;
  border: 1px solid red;
  border-radius: 3px;
}
.eBocShHzGg1byhAAkym5 form {
  inline-size: 100%;
  display: flex;
  flex-direction: column;
  margin-block-end: 20px;
}
.eBocShHzGg1byhAAkym5 form .gQ3FH_ajJ4i19w2plMAl {
  margin-block-end: 10px;
}
.eBocShHzGg1byhAAkym5 a.FNw57BSxwxoDh9tCS_j7 {
  display: block;
  align-self: end;
  margin-block: 16px;
  font-size: 0.75rem;
}
.eBocShHzGg1byhAAkym5 .bVUbDPeuiZkwPHbkP5Im {
  align-self: end;
  margin-block: 8px;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav {
  margin: 0 0 15px 0;
  inline-size: 100%;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav ul {
  padding: 0;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav li {
  margin: 16px 8px;
  list-style-type: none;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav .mOCATUxvbytV__1QzyIx {
  outline: none;
  text-decoration: none;
  text-align: center;
  padding: 8px 10px 10px 10px;
  border-radius: 4px;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav li:last-child .mOCATUxvbytV__1QzyIx {
  margin-inline-end: 0;
}
.eBocShHzGg1byhAAkym5 .c6gdrCxGw34VhON1Leav .KiY9fR024ZeIbk2Gmt54 {
  block-size: 24px;
  margin-inline-end: 6px;
  vertical-align: middle;
}
.eBocShHzGg1byhAAkym5 .DrAPemUy5fcg81A25h5Q {
  display: none;
}
.Np48vgN6DDB5GywcgFwc {
  font-size: 0.625rem;
  color: var(--cw-color-text-hint);
  text-align: center;
}
.Np48vgN6DDB5GywcgFwc .ikrh00Uz2in1WsXqoZJw {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Np48vgN6DDB5GywcgFwc .ikrh00Uz2in1WsXqoZJw > div {
  margin: 0 20px;
}
.Np48vgN6DDB5GywcgFwc .ikrh00Uz2in1WsXqoZJw a, .Np48vgN6DDB5GywcgFwc .ikrh00Uz2in1WsXqoZJw a:visited {
  color: inherit;
  text-decoration: none;
}
.Np48vgN6DDB5GywcgFwc .ikrh00Uz2in1WsXqoZJw a.T1fCuXK7odhtJDvvOJGB {
  color: #0063a3;
  text-decoration: underline;
}
.OpgFo62SudO7ZCYbJBGW {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  padding-block: 0.5rem;
}
.OpgFo62SudO7ZCYbJBGW .cw-icon-cityworks-logo {
  font-size: 1.5rem;
  color: var(--cw-color-primary);
}
`, "",{"version":3,"sources":["webpack://./projects/shared/src/global-vars.less","webpack://./projects/core-app/src/pages/log-in/log-in-form.component.less"],"names":[],"mappings":"AAAA;EACI,8CAAA;EACA,0BAAA;EACA,wBAAA;EAEA,2BAAA;EAEA,gCAAA;EACA,gDAAA;EACA,2CAAA;EAEA,6BAAA;EACA,6BAAA;EAEA,kDAAA;EACA,oDAAA;EAEA,kCAAA;ACJJ;ADbA;EAsBQ,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ACNR;AD5BA;EAsCQ,uBAAA;ACPR;AD/BA;EA0CQ,0CAAA;ACRR;ADlCA;EA8CQ,2BAAA;EACA,6BAAA;ACTR;AApCA;EAEQ,mBAAA;EACA,gBAAA;EACA,sBAAA;AAqCR;AAzCA;EAQQ,aAAA;EACA,uBAAA;EACA,uCAAA;AAoCR;AA9CA;EAcQ,mBAAA;EACA,qCAAA;AAmCR;AAlDA;EAmBQ,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EAkCN,sBAAsB;AACxB;AA3DA;EA2BY,YAAA;EACA,UAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAmCZ;AApEA;EAqCY,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAkCZ;AA1EA;EA2CgB,sBAAA;AAkChB;AA7EA;EAgDY,cAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAgCZ;AAnFA;EAwDY,eAAA;EACA,iBAAA;AA8BZ;AAvFA;EA8DY,kBAAA;EACA,iBAAA;AA4BZ;AA3FA;EAkEgB,UAAA;AA4BhB;AA9FA;EAsEgB,gBAAA;EACA,qBAAA;AA2BhB;AAlGA;EA2EgB,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;AA0BhB;AAzGA;EAmFgB,oBAAA;AAyBhB;AA5GA;EAuFgB,gBAAA;EACA,sBAAA;EACA,sBAAA;AAwBhB;AAjHA;EA8FY,aAAA;AAsBZ;AApHA;EAmGQ,mBAAA;EACA,gCAAA;EACA,kBAAA;AAoBR;AAzHA;EAwGY,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAoBZ;AAhIA;EA+GgB,cAAA;AAoBhB;AAjBY;EAEI,cAAA;EACA,qBAAA;AAmBhB;AAxIA;EA0HgB,cAAA;EACA,0BAAA;AAiBhB;AA5IA;EAiIQ,aAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;AAcR;AAlJA;EAwIgB,iBAAA;EACA,8BAAA;AAahB","sourcesContent":[":root {\n    --bgColor_appBar: var(--cw-color-back-primary);\n    --fgColor_spinner: #2e78ac;\n    --height_topAppBar: 60px;\n\n    --cw-color-primary: @col_trimble_blue_light;\n\n    --cw-color-text-primary: @col_trimble_gray;\n    --cw-color-text-secondary: fade(@col_trimble_gray, 70%);\n    --cw-color-text-hint: fade(@col_trimble_gray, 50%);\n\n    --cw-color-back-primary: @col_white;\n    --cw-color-back-blue: @col_blue_pale; // #eaf4fb?\n\n    --cw-color-divider-primary: fade(@col_trimble_gray, 65%);\n    --cw-color-divider-secondary: fade(@col_trimble_gray, 15%);\n\n    --cwui-color-palette-warn: @col_red;\n\n    // bootstrap overrides\n\n    .btn.btn-primary {\n        --bs-btn-color: @col_white;\n        --bs-btn-bg: @col_trimble_blue;\n        --bs-btn-border-color: @col_trimble_blue;\n        --bs-btn-hover-color: @col_white;\n        --bs-btn-hover-bg: #0082d6;\n        --bs-btn-hover-border-color: #0082d6;\n        --bs-btn-focus-shadow-rgb: 49, 132, 253;\n        --bs-btn-active-color: @col_white;\n        --bs-btn-active-bg: #00548a;\n        --bs-btn-active-border-color: #00548a;\n        --bs-btn-disabled-color: @col_white;\n        --bs-btn-disabled-bg: @col_trimble_blue;\n        --bs-btn-disabled-border-color: @col_trimble_blue;\n    }\n\n    .btn.btn-light {\n        --bs-btn-color: @col_trimble_gray;\n    }\n\n    .card {\n        --bs-card-bg: var(--cw-color-back-primary);\n    }\n\n    .navbar {\n        --bs-navbar-padding-x: 16px;\n        --bs-navbar-padding-y: 2.25px;\n    }\n}\n\n// dark theme overrides\n// @media (prefers-color-scheme: dark) {\n//     :root {\n//         --cw-color-back-primary: @col_trimble_gray;\n//         --cw-color-back-blue: @col_blue_dark;\n\n//         --cw-color-divider-primary: @col_white;\n//         --cw-color-divider-secondary: fade(@col_white, 40%);\n\n//         --bs-body-bg: #353a40;\n//         --bs-body-color: @col_white;\n//         --cw-color-text-primary: @col_white;\n//         --cw-color-text-secondary: fade(@col_white, 60%);\n//         --cw-color-text-hint: fade(@col_white, 40%);\n//     }\n// }\n\n// Trimble LESS Color variables\n// V4 - September 2021\n\n//Brand colors\n@col_trimble_blue_dark: #004f83;\n@col_trimble_blue: #0063a3;\n@col_trimble_blue_light: #217cbb;\n@col_trimble_yellow: #fbad26;\n@col_trimble_green: #349c44;\n@col_trimble_red: #b44e2a;\n\n//Grayscale\n@col_white: #fff;\n@col_gray_half: #f9f9fb;\n@col_gray_light: #f1f1f6;\n@col_gray_0: #e0e1e9;\n@col_gray_1: #cbcdd6;\n@col_gray_2: #b7b9c3;\n@col_gray_3: #a3a6b1;\n@col_gray_4: #90939f;\n@col_gray_5: #7d808d;\n@col_gray_6: #6a6e79;\n@col_gray_7: #585c65;\n@col_gray_8: #464b52;\n@col_gray_9: #353a40;\n@col_gray_10: #171c1e;\n@col_trimble_gray: #252a2e;\n@col_black: #000;\n\n//Blue Buttons & Notifications\n@col_blue: #0063a3;\n@col_blue_light: #217cbb;\n@col_blue_dark: #0e416c;\n@col_blue_pale: #dcedf9;\n\n//Green Buttons & Notifications\n@col_green: #1e8a44;\n@col_green_light: #4ea646;\n@col_green_dark: #006638;\n@col_green_pale: #e0eccf;\n\n//Yellow Buttons\n@col_yellow: #fbad26;\n@col_yellow_light: #fec157;\n@col_yellow_dark: #e49325;\n@col_yellow_pale: #fff5e4;\n\n//Red Buttons & Notifications\n@col_red: #da212c;\n@col_red_light: #e86363;\n@col_red_dark: #ab1f26;\n@col_red_pale: #fbd4d7;\n\n//Markup\n@col_markup: #f0f;","@import '../../../../shared/src/global-vars.less';\n\n:local {\n    h1 {\n        font-size: 1.125rem;\n        font-weight: 600;\n        margin-block-end: 24px;\n    }\n\n    .cardBody {\n        padding: 32px;\n        padding-block-end: 16px;\n        inline-size: clamp(320px, 30lvi, 500px);\n    }\n\n    .textSecondary {\n        font-size: .875rem;\n        color: var(--cw-color-text-secondary);\n    }\n\n    .formWrapper {\n        display: flex;\n        flex-direction: column;\n        flex-wrap: nowrap;\n        align-content: center;\n        justify-content: center;\n        align-items: stretch;\n\n        .errorMessageWrapper {\n            margin: 10px;\n            color: red;\n            max-inline-size: 300px;\n            background-color: #ff00000a;\n            padding: 8px;\n            border: 1px solid red;\n            border-radius: 3px;\n        }\n\n        form {\n            inline-size: 100%;\n            display: flex;\n            flex-direction: column;\n            margin-block-end: 20px;\n\n            .credentialInput {\n                margin-block-end: 10px;\n            }\n        }\n\n        a.forgotPassword {\n            display: block;\n            align-self: end;\n            margin-block: 16px;\n            font-size: .75rem;\n        }\n\n        // Override bootstrap\n        .loginButtonGroup {\n            align-self: end;\n            margin-block: 8px;\n        }\n\n        /****** oauth 2 ******/\n        .oauth2Options {\n            margin: 0 0 15px 0;\n            inline-size: 100%;\n\n            ul {\n                padding: 0;\n            }\n\n            li {\n                margin: 16px 8px;\n                list-style-type: none;\n            }\n\n            .oauth2Name {\n                outline: none;\n                text-decoration: none;\n                text-align: center;\n                padding: 8px 10px 10px 10px;\n                border-radius: 4px;\n            }\n\n            li:last-child .oauth2Name {\n                margin-inline-end: 0;\n            }\n\n            .oauth2Logo {\n                block-size: 24px;\n                margin-inline-end: 6px;\n                vertical-align: middle;\n            }\n        }\n\n        .hidden {\n            display: none;\n        }\n    }\n\n    .gridFooterRow {\n        font-size: .625rem;\n        color: var(--cw-color-text-hint);\n        text-align: center;\n\n        .footerContentWrapper {\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n\n            >div {\n                margin: 0 20px;\n            }\n\n            & a,\n            & a:visited {\n                color: inherit;\n                text-decoration: none;\n            }\n\n            // Override bootstrap\n            a.privacyNotice {\n                color: @col_trimble_blue;\n                text-decoration: underline;\n            }\n        }\n    }\n\n    .poweredBy {\n        display: flex;\n        flex-direction: column;\n        font-size: 1rem;\n        padding-block: .5rem;\n\n        :global {\n            .cw-icon-cityworks-logo {\n                font-size: 1.5rem;\n                color: var(--cw-color-primary);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `TlR_oP5QZdjlSQqYXk5F`,
	"textSecondary": `ojm_WdoHMlG3FmU_o9Zh`,
	"formWrapper": `eBocShHzGg1byhAAkym5`,
	"errorMessageWrapper": `gkpk_9wRdIUYtCtGMHzw`,
	"credentialInput": `gQ3FH_ajJ4i19w2plMAl`,
	"forgotPassword": `FNw57BSxwxoDh9tCS_j7`,
	"loginButtonGroup": `bVUbDPeuiZkwPHbkP5Im`,
	"oauth2Options": `c6gdrCxGw34VhON1Leav`,
	"oauth2Name": `mOCATUxvbytV__1QzyIx`,
	"oauth2Logo": `KiY9fR024ZeIbk2Gmt54`,
	"hidden": `DrAPemUy5fcg81A25h5Q`,
	"gridFooterRow": `Np48vgN6DDB5GywcgFwc`,
	"footerContentWrapper": `ikrh00Uz2in1WsXqoZJw`,
	"privacyNotice": `T1fCuXK7odhtJDvvOJGB`,
	"poweredBy": `OpgFo62SudO7ZCYbJBGW`
};
export default ___CSS_LOADER_EXPORT___;
